import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import { DesktopContainer } from "../layouts";
import { Row, Col, Table, Button, Input } from "reactstrap";
import { api, dateHelpers } from "../utils";
import { useGetTestResult } from "../hooks";
//import { usePreviousHook } from "../components/SpecEditComponents/index";
import ServiceThreadSpinner from "./ServiceThreadSpinner";
import { DebounceInput } from "react-debounce-input";
import { LocalNumberFormatWrapper } from "./";

export default function EditQualityTest() {
   const cancelToken = axios.CancelToken;
   const source = cancelToken.source();
   const location = useLocation();
   //const previousLocationState = usePreviousHook(location.state);
   const [isLoading, setIsLoading] = useState(false);
   const [Specification, TestResultInfo, Loading, Success] = useGetTestResult(location.state);
   const [testInfo, setTestInfo] = useState(null);

   useEffect(() => {
      if (Success === false) return;
      setTestInfo(TestResultInfo);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [Success]);

   function averageCalculator(values, yieldCal = false) {
      if (yieldCal) {
         values = _.map(values, (x) => calYieldTtl(x));
      }
      let average = 0.0;
      if (values && values.length > 1) {
         for (let index = 0; index < values.length; index++) {
            average += values[index];
         }
         average = average / values.length;
      }
      return average;
   }

   function calAverage(group) {
      let average = 0;
      switch (group) {
         case "specGrav":
            average = averageCalculator([
               testInfo.specGrav_T1_S1,
               testInfo.specGrav_T1_S3,
               testInfo.specGrav_T1_S3,
               testInfo.specGrav_T2_S1,
               testInfo.specGrav_T2_S2,
               testInfo.specGrav_T2_S3,
               testInfo.specGrav_T3_S1,
               testInfo.specGrav_T3_S2,
               testInfo.specGrav_T3_S3,
            ]);
            break;
         case "viscosityCal":
            average = averageCalculator([
               testInfo.viscosity_T1_S1,
               testInfo.viscosity_T1_S2,
               testInfo.viscosity_T1_S3,
               testInfo.viscosity_T2_S1,
               testInfo.viscosity_T2_S2,
               testInfo.viscosity_T2_S3,
               testInfo.viscosity_T3_S1,
               testInfo.viscosity_T3_S2,
               testInfo.viscosity_T3_S3,
            ]);
            break;
         case "refrIdx":
            average = averageCalculator([
               testInfo.refrIdx_T1_S1,
               testInfo.refrIdx_T1_S2,
               testInfo.refrIdx_T1_S3,
               testInfo.refrIdx_T2_S1,
               testInfo.refrIdx_T2_S2,
               testInfo.refrIdx_T2_S3,
               testInfo.refrIdx_T3_S1,
               testInfo.refrIdx_T3_S2,
               testInfo.refrIdx_T3_S3,
            ]);
            break;
         case "solids":
            average = averageCalculator([
               testInfo.solids_T1_S1,
               testInfo.solids_T1_S2,
               testInfo.solids_T1_S3,
               testInfo.solids_T2_S1,
               testInfo.solids_T2_S2,
               testInfo.solids_T2_S3,
               testInfo.solids_T3_S1,
               testInfo.solids_T3_S2,
               testInfo.solids_T3_S3,
            ]);
            break;
         case "ph":
            average = averageCalculator([
               testInfo.pH_T1_S1,
               testInfo.pH_T1_S2,
               testInfo.pH_T1_S3,
               testInfo.pH_T2_S1,
               testInfo.pH_T2_S2,
               testInfo.pH_T2_S3,
               testInfo.pH_T3_S1,
               testInfo.pH_T3_S2,
               testInfo.pH_T3_S3,
            ]);
            break;
         default:
            break;
      }
      return average;
   }

   function calStdDeviation(doubles, yieldCal = false) {
      if (yieldCal) doubles = _.map(doubles, (x) => calYieldTtl(x));
      let avg = 0;
      let variance = 0;
      let SD = 0;

      if (doubles.length > 0) {
         avg = _.mean(doubles);
         _.forEach(doubles, (val) => {
            variance += Math.pow(val - avg, 2);
         });
         variance = variance / doubles.length;
         SD = Math.sqrt(variance);
      }
      return SD;
   }

   function calTenacityTtl(strength, yarnSize) {
      let result = 0;
      if (!strength || !yarnSize) return result;
      result = _.round((strength * 453.59237) / yarnSize, 2);
      return result;
   }

   function calYieldTtl(yarnSize) {
      let result = 0;
      if (!yarnSize) return result;
      result = _.round(4464500 / yarnSize, 2);
      return result;
   }

   function coefficientOfVariation(doubles, places, yieldCal = false) {
      let roundPlaces = 2;
      if (places) roundPlaces = places;
      let stdDeviation = calStdDeviation(doubles, yieldCal);
      let mean = averageCalculator(doubles, yieldCal);
      if (!stdDeviation || !mean) return 0;
      stdDeviation = _.round(stdDeviation, roundPlaces);
      mean = _.round(mean, roundPlaces);
      let variation = 0;
      if (mean !== 0) {
         variation = (stdDeviation / mean) * 100;
      }
      return variation;
   }

   function includeTenacityAndYieldToPayload(payload) {
      payload.tenacity_T1_S1 = calTenacityTtl(
         testInfo.strength_T1_S1,
         testInfo.yarnSize_T1_S1
      );
      payload.tenacity_T1_S2 = calTenacityTtl(
         testInfo.strength_T1_S2,
         testInfo.yarnSize_T1_S2
      );
      payload.tenacity_T1_S3 = calTenacityTtl(
         testInfo.strength_T1_S3,
         testInfo.yarnSize_T1_S3
      );
      payload.tenacity_T2_S1 = calTenacityTtl(
         testInfo.strength_T2_S1,
         testInfo.yarnSize_T2_S1
      );
      payload.tenacity_T2_S2 = calTenacityTtl(
         testInfo.strength_T2_S2,
         testInfo.yarnSize_T2_S2
      );
      payload.tenacity_T2_S3 = calTenacityTtl(
         testInfo.strength_T2_S3,
         testInfo.yarnSize_T2_S3
      );
      payload.tenacity_T3_S1 = calTenacityTtl(
         testInfo.strength_T3_S1,
         testInfo.yarnSize_T3_S1
      );
      payload.tenacity_T3_S2 = calTenacityTtl(
         testInfo.strength_T3_S2,
         testInfo.yarnSize_T3_S2
      );
      payload.tenacity_T3_S3 = calTenacityTtl(
         testInfo.strength_T3_S3,
         testInfo.yarnSize_T3_S3
      );

      payload.yield_T1_S1 = calYieldTtl(testInfo.yarnSize_T1_S1);
      payload.yield_T1_S2 = calYieldTtl(testInfo.yarnSize_T1_S2);
      payload.yield_T1_S3 = calYieldTtl(testInfo.yarnSize_T1_S3);
      payload.yield_T2_S1 = calYieldTtl(testInfo.yarnSize_T2_S1);
      payload.yield_T2_S2 = calYieldTtl(testInfo.yarnSize_T2_S2);
      payload.yield_T2_S3 = calYieldTtl(testInfo.yarnSize_T2_S3);
      payload.yield_T3_S1 = calYieldTtl(testInfo.yarnSize_T3_S1);
      payload.yield_T3_S2 = calYieldTtl(testInfo.yarnSize_T3_S2);
      payload.yield_T3_S3 = calYieldTtl(testInfo.yarnSize_T3_S3);

      return payload;
   }

   function LocalDebounceFormatterReadOnly({ value, padding, light }) {
      const [valueProp, setValueProp] = useState(value);

      useEffect(() => {
         setValueProp(_.toNumber(value).toFixed(padding));
         // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

      if (padding) {
         return (
            <Col xs="12">
               <DebounceInput
                  //   key={value}
                  style={{ textAlign: "right" }}
                  element={"input"}
                  className={"form-control"}
                  value={valueProp}
                  readOnly={true}
                  disabled={true}
               />
            </Col>
         );
      } else {
         if (light) {
            return (
               <Col xs="12">
                  <DebounceInput
                     //   key={value}
                     style={{
                        textAlign: "right",
                        fontWeight: "bold",
                        backgroundColor: "#2b72b9",
                        color: "white",
                        border: "1px solid #2b72b9",
                     }}
                     element={"input"}
                     className={"form-control"}
                     value={value}
                     readOnly={true}
                     disabled={true}
                  />
               </Col>
            );
         } else {
            return (
               <Col xs="12">
                  <DebounceInput
                     //   key={value}
                     style={{
                        textAlign: "right",
                        fontWeight: "bold",
                        color: "white",
                        backgroundColor: "#275d91",
                        border: "1px solid #275d91",
                     }}
                     element={"input"}
                     className={"form-control"}
                     value={value}
                     readOnly={true}
                     disabled={true}
                  />
               </Col>
            );
         }
      }
   }

   function onChange(propertyName, value) {
      let copy = _.cloneDeep(testInfo);
      copy[propertyName] = value;
      setTestInfo(copy);
   }

   const SaveTestData = () => {
      let payload = _.cloneDeep(testInfo);
      let reshapedPayload = includeTenacityAndYieldToPayload(payload);
      setIsLoading(true);
      api
         .postS(`Quality/SaveTestData`, reshapedPayload, source.token)
         .then((response) => {
            if (response.data.success) {
               toast.success("Successful Save!");
            } else {
               toast.error("failed to save the test data");
               throw new Error(
                  `failed to save the test data, error message: ${response.data.message}`
               );
            }
         })
         .catch(api.catchHandler)
         .finally(() => setIsLoading(false));
   };

   return (
      <DesktopContainer screenName={""}>
         <ServiceThreadSpinner
            on={Loading}
            children={
               testInfo ? (
                  <div>
                     <Table className={"verticalTable"}>
                        <thead>
                           <tr className="bg-white-black">
                              <th className="text-black-blue">
                                 <h5>Test #:</h5>
                              </th>
                              <th className="text-blue">
                                 <h5>{TestResultInfo?.testID}</h5>
                              </th>
                           </tr>
                           <tr className="bg-white-black" style={{ width: "15%" }}>
                              <th className="text-black-blue">
                                 <h5>Test Date:</h5>
                              </th>
                              <th className="text-blue">
                                 <h5>{dateHelpers.toLongDateString(TestResultInfo?.testDate)}</h5>
                              </th>
                           </tr>
                           <tr></tr>
                           <tr className="bg-white-black ">
                              <th className="text-black-blue">
                                 <h5>Item:</h5>
                              </th>
                              <th className="text-blue">
                                 <h5>{Specification?.itemWithDesc}</h5>
                              </th>
                           </tr>
                           <tr />
                        </thead>
                        <thead>
                           <tr>
                              <th className="text-black-blue">
                                 <h5>Spec:</h5>
                              </th>
                              <th className="text-blue">
                                 <h5>{TestResultInfo?.specNumber}</h5>
                              </th>
                           </tr>
                           <tr>
                              <th className="text-black-blue">
                                 <h5>Rev Date:</h5>
                              </th>
                              <th className="text-blue">
                                 <h5>{dateHelpers.toLongDateString(Specification?.revDate)}</h5>
                              </th>
                           </tr>
                           <tr>
                              <th className="text-black-blue">
                                 <h5>Rev #:</h5>
                              </th>
                              <th className="text-blue">
                                 <h5>{Specification?.revNumber}</h5>
                              </th>
                           </tr>
                           <tr>
                              <th className="text-black-blue">
                                 <h5>Operator:</h5>
                              </th>
                              <th className="text-blue" style={{ width: "100%" }}>
                                 <h5>
                                    {
                                       <Input
                                          value={testInfo?.testOperator}
                                          onChange={(e) => onChange("testOperator", e.target.value)}
                                       />
                                    }
                                 </h5>
                              </th>
                           </tr>
                           <tr style={{ width: "10%" }} />
                        </thead>
                     </Table>
                     <div className="filter-header m2-5 p-3">
                        <Table className={"verticalTable"}>
                           <tbody>
                              <tr style={{ border: "1px solid #4997d0", borderTop: "none", borderBottom: "none" }} >
                                 <td className="text-blue">
                                    <h5>&nbsp;</h5>
                                 </td>
                                 <td className="text-white" style={{ textAlign: "right" }}>
                                    <h5>Test #</h5>
                                 </td>
                                 <td className="text-blue">
                                    <h5>&nbsp;</h5>
                                 </td>
                                 <td
                                    style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                    children={
                                       <LocalDebounceFormatterReadOnly value={"1"} />
                                    }
                                 />
                                 <td
                                    style={{ backgroundColor: "#275d91" }}
                                    children={
                                       <LocalDebounceFormatterReadOnly value={"Sample 1    2"} />
                                    }
                                 />
                                 <td
                                    style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                    children={
                                       <LocalDebounceFormatterReadOnly value={"3"} />
                                    }
                                 />
                                 <td
                                    children={
                                       <LocalDebounceFormatterReadOnly light value={"1"} />
                                    }
                                 />
                                 <td
                                    children={
                                       <LocalDebounceFormatterReadOnly light value={"Sample 2    2"} />
                                    }
                                 />
                                 <td
                                    children={
                                       <LocalDebounceFormatterReadOnly light value={"3"} />
                                    }
                                 />
                                 <td
                                    style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                    children={
                                       <LocalDebounceFormatterReadOnly value={"1"} />
                                    }
                                 />
                                 <td
                                    style={{ backgroundColor: "#275d91" }}
                                    children={
                                       <LocalDebounceFormatterReadOnly
                                          value={"Sample 3    2"}
                                       />
                                    }
                                 />
                                 <td
                                    style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                    children={
                                       <LocalDebounceFormatterReadOnly value={"3"} />
                                    }
                                 />
                                 <td
                                    children={
                                       <LocalDebounceFormatterReadOnly light value={"Average"} />
                                    }
                                 />
                                 <td
                                    children={
                                       <LocalDebounceFormatterReadOnly light value={"Std. Deviation"} />
                                    }
                                 />
                                 <td
                                    children={
                                       <LocalDebounceFormatterReadOnly light value={"CV"} />
                                    }
                                 />
                              </tr>

                              {Specification?.isChemClass && (
                                 <>
                                    {Specification.calViscosity ? (
                                       <tr>
                                          <td className="text-blue text-center">
                                             <h5>&nbsp;</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>Viscosity (cP)</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`${_.toNumber(Specification.viscosityMin).toFixed(1)} - ${_.toNumber(Specification.viscosityMax).toFixed(1)}`}</h5>
                                          </td>
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"viscosity_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.viscosityMin}
                                                   max={Specification.viscosityMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"viscosity_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.viscosityMin}
                                                   max={Specification.viscosityMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"viscosity_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.viscosityMin}
                                                   max={Specification.viscosityMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"viscosity_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.viscosityMin}
                                                   max={Specification.viscosityMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"viscosity_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.viscosityMin}
                                                   max={Specification.viscosityMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"viscosity_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.viscosityMin}
                                                   max={Specification.viscosityMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"viscosity_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.viscosityMin}
                                                   max={Specification.viscosityMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"viscosity_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.viscosityMin}
                                                   max={Specification.viscosityMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"viscosity_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.viscosityMin}
                                                   max={Specification.viscosityMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly value={calAverage("viscosityCal")} padding={1} />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly value={"N/A"} />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly value={"N/A"} />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calPH ? (
                                       <tr>
                                          <td className="text-blue text-center">
                                             <h5>&nbsp;</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>pH</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`${_.toNumber(Specification.phMin).toFixed(1)} - ${_.toNumber(Specification.phMax).toFixed(1)}`}</h5>
                                          </td>
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"pH_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.phMin}
                                                   max={Specification.phMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"pH_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.phMin}
                                                   max={Specification.phMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"pH_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.phMin}
                                                   max={Specification.phMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"pH_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.phMin}
                                                   max={Specification.phMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"pH_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.phMin}
                                                   max={Specification.phMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"pH_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.phMin}
                                                   max={Specification.phMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"pH_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.phMin}
                                                   max={Specification.phMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"pH_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.phMin}
                                                   max={Specification.phMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"pH_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.phMin}
                                                   max={Specification.phMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly value={calAverage("ph")} padding={1} />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly value={"N/A"} />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly value={"N/A"} />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calSolids ? (
                                       <tr>
                                          <td className="text-blue text-center">
                                             <h5>&nbsp;</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>Solids (%)</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`${_.toNumber(Specification.solidsMin).toFixed(1)} - ${_.toNumber(Specification.solidsMax).toFixed(1)}`}</h5>
                                          </td>
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"solids_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.solidsMin}
                                                   max={Specification.solidsMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"solids_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.solidsMin}
                                                   max={Specification.solidsMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"solids_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.solidsMin}
                                                   max={Specification.solidsMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"solids_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.solidsMin}
                                                   max={Specification.solidsMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"solids_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.solidsMin}
                                                   max={Specification.solidsMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"solids_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.solidsMin}
                                                   max={Specification.solidsMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"solids_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.solidsMin}
                                                   max={Specification.solidsMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"solids_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.solidsMin}
                                                   max={Specification.solidsMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"solids_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.solidsMin}
                                                   max={Specification.solidsMax}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly value={calAverage("solids")} padding={1} />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly value={"N/A"} />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly value={"N/A"} />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calRefrIdx ? (
                                       <tr>
                                          <td className="text-blue text-center">
                                             <h5>&nbsp;</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>Refractive Index (n)</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`${_.toNumber(Specification.refractiveIdxMin).toFixed(4)} - ${_.toNumber(Specification.refractiveIdxMax).toFixed(4)}`}</h5>
                                          </td>
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"refrIdx_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.refractiveIdxMin}
                                                   max={Specification.refractiveIdxMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"refrIdx_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.refractiveIdxMin}
                                                   max={Specification.refractiveIdxMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"refrIdx_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.refractiveIdxMin}
                                                   max={Specification.refractiveIdxMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"refrIdx_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.refractiveIdxMin}
                                                   max={Specification.refractiveIdxMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"refrIdx_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.refractiveIdxMin}
                                                   max={Specification.refractiveIdxMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"refrIdx_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.refractiveIdxMin}
                                                   max={Specification.refractiveIdxMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"refrIdx_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.refractiveIdxMin}
                                                   max={Specification.refractiveIdxMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"refrIdx_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.refractiveIdxMin}
                                                   max={Specification.refractiveIdxMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"refrIdx_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.refractiveIdxMin}
                                                   max={Specification.refractiveIdxMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly value={calAverage("refrIdx")} padding={4} />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly value={"N/A"} />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly value={"N/A"} />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calSpecGrav ? (
                                       <tr>
                                          <td className="text-blue text-center">
                                             <h5>&nbsp;</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>Specific Gravity (SG)</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`${_.toNumber(Specification.specificGravityMin).toFixed(4)} - ${_.toNumber(Specification.specificGravityMax).toFixed(4)}`}</h5>
                                          </td>
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"specGrav_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.specificGravityMin}
                                                   max={Specification.specificGravityMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"specGrav_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.specificGravityMin}
                                                   max={Specification.specificGravityMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"specGrav_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.specificGravityMin}
                                                   max={Specification.specificGravityMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"specGrav_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.specificGravityMin}
                                                   max={Specification.specificGravityMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"specGrav_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.specificGravityMin}
                                                   max={Specification.specificGravityMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"specGrav_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.specificGravityMin}
                                                   max={Specification.specificGravityMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"specGrav_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.specificGravityMin}
                                                   max={Specification.specificGravityMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"specGrav_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.specificGravityMin}
                                                   max={Specification.specificGravityMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"specGrav_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.specificGravityMin}
                                                   max={Specification.specificGravityMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly value={calAverage("specGrav")} padding={4} />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly value={"N/A"} />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly value={"N/A"} />
                                             }
                                          />
                                       </tr>
                                    ) : null}
                                 </>
                              )}

                              {Specification.isPkgClass && null}

                              {!Specification.isChemClass && !Specification.isPkgClass && (
                                 <>
                                    <tr
                                       className="verticalTableBorders"
                                       style={{ border: "1px solid #4997d0", borderTop: "none", borderBottom: "none" }}
                                    >
                                       <td className="text-white text-center">
                                          <h5>Yarn Size</h5>
                                       </td>
                                       <td className="text-white text-center">
                                          <h5>Denier</h5>
                                       </td>
                                       <td className="text-white text-center">
                                          <h5>{`${_.toNumber(Specification.yarnSizeMinTotalEnds).toFixed(2)} - ${_.toNumber(Specification.yarnSizeMaxTotalEnds).toFixed(2)}`}</h5>
                                       </td>
                                       <td
                                          style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"yarnSize_T1_S1"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.yarnSizeMinTotalEnds}
                                                max={Specification.yarnSizeMaxTotalEnds}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ backgroundColor: "#275d91" }}
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"yarnSize_T1_S2"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.yarnSizeMinTotalEnds}
                                                max={Specification.yarnSizeMaxTotalEnds}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"yarnSize_T1_S3"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.yarnSizeMinTotalEnds}
                                                max={Specification.yarnSizeMaxTotalEnds}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"yarnSize_T2_S1"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.yarnSizeMinTotalEnds}
                                                max={Specification.yarnSizeMaxTotalEnds}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"yarnSize_T2_S2"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.yarnSizeMinTotalEnds}
                                                max={Specification.yarnSizeMaxTotalEnds}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"yarnSize_T2_S3"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.yarnSizeMinTotalEnds}
                                                max={Specification.yarnSizeMaxTotalEnds}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"yarnSize_T3_S1"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.yarnSizeMinTotalEnds}
                                                max={Specification.yarnSizeMaxTotalEnds}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ backgroundColor: "#275d91" }}
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"yarnSize_T3_S2"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.yarnSizeMinTotalEnds}
                                                max={Specification.yarnSizeMaxTotalEnds}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"yarnSize_T3_S3"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.yarnSizeMinTotalEnds}
                                                max={Specification.yarnSizeMaxTotalEnds}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={averageCalculator([
                                                   testInfo.yarnSize_T1_S1,
                                                   testInfo.yarnSize_T1_S2,
                                                   testInfo.yarnSize_T1_S3,
                                                   testInfo.yarnSize_T2_S1,
                                                   testInfo.yarnSize_T2_S2,
                                                   testInfo.yarnSize_T2_S3,
                                                   testInfo.yarnSize_T3_S1,
                                                   testInfo.yarnSize_T3_S2,
                                                   testInfo.yarnSize_T3_S3,
                                                ])}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={calStdDeviation([
                                                   testInfo.yarnSize_T1_S1,
                                                   testInfo.yarnSize_T1_S2,
                                                   testInfo.yarnSize_T1_S3,
                                                   testInfo.yarnSize_T2_S1,
                                                   testInfo.yarnSize_T2_S2,
                                                   testInfo.yarnSize_T2_S3,
                                                   testInfo.yarnSize_T3_S1,
                                                   testInfo.yarnSize_T3_S2,
                                                   testInfo.yarnSize_T3_S3,
                                                ])}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={coefficientOfVariation([
                                                   testInfo.yarnSize_T1_S1,
                                                   testInfo.yarnSize_T1_S2,
                                                   testInfo.yarnSize_T1_S3,
                                                   testInfo.yarnSize_T2_S1,
                                                   testInfo.yarnSize_T2_S2,
                                                   testInfo.yarnSize_T2_S3,
                                                   testInfo.yarnSize_T3_S1,
                                                   testInfo.yarnSize_T3_S2,
                                                   testInfo.yarnSize_T3_S3,
                                                ])}
                                                padding={2}
                                             />
                                          }
                                       />
                                    </tr>

                                    <tr style={{ border: "1px solid #4997d0", borderTop: "none", borderBottom: "none" }} >
                                       <td className="text-white text-center">
                                          <h5>Breaking</h5>
                                       </td>
                                       <td className="text-white text-center">
                                          <h5>Strength (lbs)</h5>
                                       </td>
                                       <td className="text-white text-center">
                                          <h5>{`Min: ${_.toNumber(Specification.strengthMinTotalEnds).toFixed(2)}`}</h5>
                                       </td>
                                       <td
                                          style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"strength_T1_S1"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.strengthMinTotalEnds}
                                                max={Number.MAX_VALUE}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ backgroundColor: "#275d91" }}
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"strength_T1_S2"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.strengthMinTotalEnds}
                                                max={Number.MAX_VALUE}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"strength_T1_S3"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.strengthMinTotalEnds}
                                                max={Number.MAX_VALUE}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ borderBottom: "1px solid white" }}
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"strength_T2_S1"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.strengthMinTotalEnds}
                                                max={Number.MAX_VALUE}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"strength_T2_S2"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.strengthMinTotalEnds}
                                                max={Number.MAX_VALUE}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"strength_T2_S3"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.strengthMinTotalEnds}
                                                max={Number.MAX_VALUE}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"strength_T3_S1"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.strengthMinTotalEnds}
                                                max={Number.MAX_VALUE}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ backgroundColor: "#275d91" }}
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"strength_T3_S2"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.strengthMinTotalEnds}
                                                max={Number.MAX_VALUE}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                          children={
                                             <LocalNumberFormatWrapper
                                                onChangeString={"strength_T3_S3"}
                                                allowZeroPRP={false}
                                                onChange={onChange}
                                                testInfo={testInfo}
                                                min={Specification.strengthMinTotalEnds}
                                                max={Number.MAX_VALUE}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={averageCalculator([
                                                   testInfo.strength_T1_S1,
                                                   testInfo.strength_T1_S2,
                                                   testInfo.strength_T1_S3,
                                                   testInfo.strength_T2_S1,
                                                   testInfo.strength_T2_S2,
                                                   testInfo.strength_T2_S3,
                                                   testInfo.strength_T3_S1,
                                                   testInfo.strength_T3_S2,
                                                   testInfo.strength_T3_S3,
                                                ])}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={calStdDeviation([
                                                   testInfo.strength_T1_S1,
                                                   testInfo.strength_T1_S2,
                                                   testInfo.strength_T1_S3,
                                                   testInfo.strength_T2_S1,
                                                   testInfo.strength_T2_S2,
                                                   testInfo.strength_T2_S3,
                                                   testInfo.strength_T3_S1,
                                                   testInfo.strength_T3_S2,
                                                   testInfo.strength_T3_S3,
                                                ])}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={coefficientOfVariation([
                                                   testInfo.strength_T1_S1,
                                                   testInfo.strength_T1_S2,
                                                   testInfo.strength_T1_S3,
                                                   testInfo.strength_T2_S1,
                                                   testInfo.strength_T2_S2,
                                                   testInfo.strength_T2_S3,
                                                   testInfo.strength_T3_S1,
                                                   testInfo.strength_T3_S2,
                                                   testInfo.strength_T3_S3,
                                                ])}
                                                padding={2}
                                             />
                                          }
                                       />
                                    </tr>

                                    {Specification.calTenacity ? (
                                       <tr style={{ border: "1px solid #4997d0", borderTop: "none", borderBottom: "none" }} >
                                          <td className="text-white text-center">
                                             <h5>Grams per</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>Denier g/dn</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`Min: ${_.toNumber(Specification.tenacityMin).toFixed(2)}`}</h5>
                                          </td>
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calTenacityTtl(
                                                      testInfo.strength_T1_S1,
                                                      testInfo.yarnSize_T1_S1
                                                   )}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calTenacityTtl(
                                                      testInfo.strength_T1_S2,
                                                      testInfo.yarnSize_T1_S2
                                                   )}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calTenacityTtl(
                                                      testInfo.strength_T1_S3,
                                                      testInfo.yarnSize_T1_S3
                                                   )}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calTenacityTtl(
                                                      testInfo.strength_T2_S1,
                                                      testInfo.yarnSize_T2_S1
                                                   )}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calTenacityTtl(
                                                      testInfo.strength_T2_S2,
                                                      testInfo.yarnSize_T2_S2
                                                   )}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calTenacityTtl(
                                                      testInfo.strength_T2_S3,
                                                      testInfo.yarnSize_T2_S3
                                                   )}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calTenacityTtl(
                                                      testInfo.strength_T3_S1,
                                                      testInfo.yarnSize_T3_S1
                                                   )}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calTenacityTtl(
                                                      testInfo.strength_T3_S2,
                                                      testInfo.yarnSize_T3_S2
                                                   )}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calTenacityTtl(
                                                      testInfo.strength_T3_S3,
                                                      testInfo.yarnSize_T3_S3
                                                   )}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={averageCalculator(
                                                      [
                                                         calTenacityTtl(
                                                            testInfo.strength_T1_S1,
                                                            testInfo.yarnSize_T1_S1
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T1_S2,
                                                            testInfo.yarnSize_T1_S2
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T1_S3,
                                                            testInfo.yarnSize_T1_S3
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T2_S1,
                                                            testInfo.yarnSize_T2_S1
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T2_S2,
                                                            testInfo.yarnSize_T2_S2
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T2_S3,
                                                            testInfo.yarnSize_T2_S3
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T3_S1,
                                                            testInfo.yarnSize_T3_S1
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T3_S2,
                                                            testInfo.yarnSize_T3_S2
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T3_S3,
                                                            testInfo.yarnSize_T3_S3
                                                         ),
                                                      ],
                                                      false
                                                   )}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calStdDeviation(
                                                      [
                                                         calTenacityTtl(
                                                            testInfo.strength_T1_S1,
                                                            testInfo.yarnSize_T1_S1
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T1_S2,
                                                            testInfo.yarnSize_T1_S2
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T1_S3,
                                                            testInfo.yarnSize_T1_S3
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T2_S1,
                                                            testInfo.yarnSize_T2_S1
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T2_S2,
                                                            testInfo.yarnSize_T2_S2
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T2_S3,
                                                            testInfo.yarnSize_T2_S3
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T3_S1,
                                                            testInfo.yarnSize_T3_S1
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T3_S2,
                                                            testInfo.yarnSize_T3_S2
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T3_S3,
                                                            testInfo.yarnSize_T3_S3
                                                         ),
                                                      ],
                                                      false
                                                   )}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={coefficientOfVariation(
                                                      [
                                                         calTenacityTtl(
                                                            testInfo.strength_T1_S1,
                                                            testInfo.yarnSize_T1_S1
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T1_S2,
                                                            testInfo.yarnSize_T1_S2
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T1_S3,
                                                            testInfo.yarnSize_T1_S3
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T2_S1,
                                                            testInfo.yarnSize_T2_S1
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T2_S2,
                                                            testInfo.yarnSize_T2_S2
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T2_S3,
                                                            testInfo.yarnSize_T2_S3
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T3_S1,
                                                            testInfo.yarnSize_T3_S1
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T3_S2,
                                                            testInfo.yarnSize_T3_S2
                                                         ),
                                                         calTenacityTtl(
                                                            testInfo.strength_T3_S3,
                                                            testInfo.yarnSize_T3_S3
                                                         ),
                                                      ],
                                                      false
                                                   )}
                                                   padding={2}
                                                />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calElong ? (
                                       <tr style={{ border: "1px solid #4997d0", borderTop: "none", borderBottom: "none" }} >
                                          <td className="text-white text-center">
                                             <h5>Elongation @</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>Break %</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`${_.toNumber(
                                                Specification.elongMin
                                             ).toFixed(2)} - ${_.toNumber(
                                                Specification.elongMax
                                             ).toFixed(2)}`}</h5>
                                          </td>
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"elong_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.elongMin}
                                                   max={Specification.elongMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"elong_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.elongMin}
                                                   max={Specification.elongMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"elong_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.elongMin}
                                                   max={Specification.elongMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"elong_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.elongMin}
                                                   max={Specification.elongMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"elong_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.elongMin}
                                                   max={Specification.elongMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"elong_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.elongMin}
                                                   max={Specification.elongMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"elong_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.elongMin}
                                                   max={Specification.elongMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"elong_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.elongMin}
                                                   max={Specification.elongMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"elong_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.elongMin}
                                                   max={Specification.elongMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={averageCalculator([
                                                      testInfo.elong_T1_S1,
                                                      testInfo.elong_T1_S2,
                                                      testInfo.elong_T1_S3,
                                                      testInfo.elong_T2_S1,
                                                      testInfo.elong_T2_S2,
                                                      testInfo.elong_T2_S3,
                                                      testInfo.elong_T3_S1,
                                                      testInfo.elong_T3_S2,
                                                      testInfo.elong_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calStdDeviation([
                                                      testInfo.elong_T1_S1,
                                                      testInfo.elong_T1_S2,
                                                      testInfo.elong_T1_S3,
                                                      testInfo.elong_T2_S1,
                                                      testInfo.elong_T2_S2,
                                                      testInfo.elong_T2_S3,
                                                      testInfo.elong_T3_S1,
                                                      testInfo.elong_T3_S2,
                                                      testInfo.elong_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={coefficientOfVariation([
                                                      testInfo.elong_T1_S1,
                                                      testInfo.elong_T1_S2,
                                                      testInfo.elong_T1_S3,
                                                      testInfo.elong_T2_S1,
                                                      testInfo.elong_T2_S2,
                                                      testInfo.elong_T2_S3,
                                                      testInfo.elong_T3_S1,
                                                      testInfo.elong_T3_S2,
                                                      testInfo.elong_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calEASL ? (
                                       <tr style={{ border: "1px solid #4997d0", borderTop: "none", borderBottom: "none" }} >
                                          <td className="text-blue text-center">
                                             <h5>&nbsp;</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>EASL @ 10 lbs</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`${_.toNumber(
                                                Specification.easlMin
                                             ).toFixed(2)} - ${_.toNumber(
                                                Specification.easlMax
                                             ).toFixed(2)}`}</h5>
                                          </td>
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"easl_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.easlMin}
                                                   max={Specification.easlMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"easl_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.easlMin}
                                                   max={Specification.easlMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"easl_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.easlMin}
                                                   max={Specification.easlMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"easl_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.easlMin}
                                                   max={Specification.easlMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"easl_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.easlMin}
                                                   max={Specification.easlMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"easl_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.easlMin}
                                                   max={Specification.easlMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"easl_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.easlMin}
                                                   max={Specification.easlMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"easl_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.easlMin}
                                                   max={Specification.easlMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"easl_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.easlMin}
                                                   max={Specification.easlMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={averageCalculator([
                                                      testInfo.easl_T1_S1,
                                                      testInfo.easl_T1_S2,
                                                      testInfo.easl_T1_S3,
                                                      testInfo.easl_T2_S1,
                                                      testInfo.easl_T2_S2,
                                                      testInfo.easl_T2_S3,
                                                      testInfo.easl_T3_S1,
                                                      testInfo.easl_T3_S2,
                                                      testInfo.easl_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calStdDeviation([
                                                      testInfo.easl_T1_S1,
                                                      testInfo.easl_T1_S2,
                                                      testInfo.easl_T1_S3,
                                                      testInfo.easl_T2_S1,
                                                      testInfo.easl_T2_S2,
                                                      testInfo.easl_T2_S3,
                                                      testInfo.easl_T3_S1,
                                                      testInfo.easl_T3_S2,
                                                      testInfo.easl_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={coefficientOfVariation([
                                                      testInfo.easl_T1_S1,
                                                      testInfo.easl_T1_S2,
                                                      testInfo.easl_T1_S3,
                                                      testInfo.easl_T2_S1,
                                                      testInfo.easl_T2_S2,
                                                      testInfo.easl_T2_S3,
                                                      testInfo.easl_T3_S1,
                                                      testInfo.easl_T3_S2,
                                                      testInfo.easl_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calLase05 ? (
                                       <tr style={{ border: "1px solid #4997d0", borderTop: "none", borderBottom: "none" }} >
                                          <td className="text-blue text-center">
                                             <h5>&nbsp;</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>LASE @ 0.5 %</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`${_.toNumber(
                                                Specification.lase05Min
                                             ).toFixed(2)} - ${_.toNumber(
                                                Specification.lase05Max
                                             ).toFixed(2)}`}</h5>
                                          </td>
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase05_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase05Min}
                                                   max={Specification.lase05Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase05_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase05Min}
                                                   max={Specification.lase05Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase05_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase05Min}
                                                   max={Specification.lase05Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase05_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase05Min}
                                                   max={Specification.lase05Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase05_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase05Min}
                                                   max={Specification.lase05Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase05_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase05Min}
                                                   max={Specification.lase05Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase05_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase05Min}
                                                   max={Specification.lase05Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase05_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase05Min}
                                                   max={Specification.lase05Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase05_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase05Min}
                                                   max={Specification.lase05Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={averageCalculator([
                                                      testInfo.lase05_T1_S1,
                                                      testInfo.lase05_T1_S2,
                                                      testInfo.lase05_T1_S3,
                                                      testInfo.lase05_T2_S1,
                                                      testInfo.lase05_T2_S2,
                                                      testInfo.lase05_T2_S3,
                                                      testInfo.lase05_T3_S1,
                                                      testInfo.lase05_T3_S2,
                                                      testInfo.lase05_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calStdDeviation([
                                                      testInfo.lase05_T1_S1,
                                                      testInfo.lase05_T1_S2,
                                                      testInfo.lase05_T1_S3,
                                                      testInfo.lase05_T2_S1,
                                                      testInfo.lase05_T2_S2,
                                                      testInfo.lase05_T2_S3,
                                                      testInfo.lase05_T3_S1,
                                                      testInfo.lase05_T3_S2,
                                                      testInfo.lase05_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={coefficientOfVariation([
                                                      testInfo.lase05_T1_S1,
                                                      testInfo.lase05_T1_S2,
                                                      testInfo.lase05_T1_S3,
                                                      testInfo.lase05_T2_S1,
                                                      testInfo.lase05_T2_S2,
                                                      testInfo.lase05_T2_S3,
                                                      testInfo.lase05_T3_S1,
                                                      testInfo.lase05_T3_S2,
                                                      testInfo.lase05_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calLase10 ? (
                                       <tr
                                          style={{
                                             border: "1px solid #4997d0",
                                             borderTop: "none",
                                             borderBottom: "none",
                                          }}
                                       >
                                          <td className="text-blue text-center">
                                             <h5>&nbsp;</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>LASE @ 1.0 %</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`${_.toNumber(
                                                Specification.lase10Min
                                             ).toFixed(2)} - ${_.toNumber(
                                                Specification.lase10Max
                                             ).toFixed(2)}`}</h5>
                                          </td>
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase10_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase10Min}
                                                   max={Specification.lase10Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase10_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase10Min}
                                                   max={Specification.lase10Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase10_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase10Min}
                                                   max={Specification.lase10Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase10_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase10Min}
                                                   max={Specification.lase10Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase10_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase10Min}
                                                   max={Specification.lase10Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase10_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase10Min}
                                                   max={Specification.lase10Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase10_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase10Min}
                                                   max={Specification.lase10Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase10_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase10Min}
                                                   max={Specification.lase10Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"lase10_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.lase10Min}
                                                   max={Specification.lase10Max}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={averageCalculator([
                                                      testInfo.lase10_T1_S1,
                                                      testInfo.lase10_T1_S2,
                                                      testInfo.lase10_T1_S3,
                                                      testInfo.lase10_T2_S1,
                                                      testInfo.lase10_T2_S2,
                                                      testInfo.lase10_T2_S3,
                                                      testInfo.lase10_T3_S1,
                                                      testInfo.lase10_T3_S2,
                                                      testInfo.lase10_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calStdDeviation([
                                                      testInfo.lase10_T1_S1,
                                                      testInfo.lase10_T1_S2,
                                                      testInfo.lase10_T1_S3,
                                                      testInfo.lase10_T2_S1,
                                                      testInfo.lase10_T2_S2,
                                                      testInfo.lase10_T2_S3,
                                                      testInfo.lase10_T3_S1,
                                                      testInfo.lase10_T3_S2,
                                                      testInfo.lase10_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={coefficientOfVariation([
                                                      testInfo.lase10_T1_S1,
                                                      testInfo.lase10_T1_S2,
                                                      testInfo.lase10_T1_S3,
                                                      testInfo.lase10_T2_S1,
                                                      testInfo.lase10_T2_S2,
                                                      testInfo.lase10_T2_S3,
                                                      testInfo.lase10_T3_S1,
                                                      testInfo.lase10_T3_S2,
                                                      testInfo.lase10_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calModulus ? (
                                       <tr
                                          style={{
                                             border: "1px solid #4997d0",
                                             borderTop: "none",
                                             borderBottom: "none",
                                          }}
                                       >
                                          <td className="text-white text-center">
                                             <h5>Young's</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>Modulus</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`Min: ${_.toNumber(Specification.modulusMin).toFixed(1)}`}</h5>
                                          </td>
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"modulus_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.modulusMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"modulus_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.modulusMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"modulus_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.modulusMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"modulus_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.modulusMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"modulus_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.modulusMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"modulus_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.modulusMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"modulus_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.modulusMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"modulus_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.modulusMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"modulus_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.modulusMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={averageCalculator([
                                                      testInfo.modulus_T1_S1,
                                                      testInfo.modulus_T1_S2,
                                                      testInfo.modulus_T1_S3,
                                                      testInfo.modulus_T2_S1,
                                                      testInfo.modulus_T2_S2,
                                                      testInfo.modulus_T2_S3,
                                                      testInfo.modulus_T3_S1,
                                                      testInfo.modulus_T3_S2,
                                                      testInfo.modulus_T3_S3,
                                                   ])}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calStdDeviation([
                                                      testInfo.modulus_T1_S1,
                                                      testInfo.modulus_T1_S2,
                                                      testInfo.modulus_T1_S3,
                                                      testInfo.modulus_T2_S1,
                                                      testInfo.modulus_T2_S2,
                                                      testInfo.modulus_T2_S3,
                                                      testInfo.modulus_T3_S1,
                                                      testInfo.modulus_T3_S2,
                                                      testInfo.modulus_T3_S3,
                                                   ])}
                                                   padding={1}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={coefficientOfVariation(
                                                      [
                                                         testInfo.modulus_T1_S1,
                                                         testInfo.modulus_T1_S2,
                                                         testInfo.modulus_T1_S3,
                                                         testInfo.modulus_T2_S1,
                                                         testInfo.modulus_T2_S2,
                                                         testInfo.modulus_T2_S3,
                                                         testInfo.modulus_T3_S1,
                                                         testInfo.modulus_T3_S2,
                                                         testInfo.modulus_T3_S3,
                                                      ],
                                                      1
                                                   )}
                                                   padding={1}
                                                />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calTensile ? (
                                       <tr
                                          style={{
                                             border: "1px solid #4997d0",
                                             borderTop: "none",
                                             borderBottom: "none",
                                          }}
                                       >
                                          <td className="text-white text-center">
                                             <h5>Tensile</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>Modulus (lbf)</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`Min: ${_.toNumber(Specification.tensileMin).toFixed(2)}`}</h5>
                                          </td>
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"tensile_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.tensileMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"tensile_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.tensileMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"tensile_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.tensileMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"tensile_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.tensileMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"tensile_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.tensileMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"tensile_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.tensileMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"tensile_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.tensileMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"tensile_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.tensileMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"tensile_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.tensileMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={averageCalculator([
                                                      testInfo.tensile_T1_S1,
                                                      testInfo.tensile_T1_S2,
                                                      testInfo.tensile_T1_S3,
                                                      testInfo.tensile_T2_S1,
                                                      testInfo.tensile_T2_S2,
                                                      testInfo.tensile_T2_S3,
                                                      testInfo.tensile_T3_S1,
                                                      testInfo.tensile_T3_S2,
                                                      testInfo.tensile_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calStdDeviation([
                                                      testInfo.tensile_T1_S1,
                                                      testInfo.tensile_T1_S2,
                                                      testInfo.tensile_T1_S3,
                                                      testInfo.tensile_T2_S1,
                                                      testInfo.tensile_T2_S2,
                                                      testInfo.tensile_T2_S3,
                                                      testInfo.tensile_T3_S1,
                                                      testInfo.tensile_T3_S2,
                                                      testInfo.tensile_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={coefficientOfVariation(
                                                      [
                                                         testInfo.tensile_T1_S1,
                                                         testInfo.tensile_T1_S2,
                                                         testInfo.tensile_T1_S3,
                                                         testInfo.tensile_T2_S1,
                                                         testInfo.tensile_T2_S2,
                                                         testInfo.tensile_T2_S3,
                                                         testInfo.tensile_T3_S1,
                                                         testInfo.tensile_T3_S2,
                                                         testInfo.tensile_T3_S3,
                                                      ],
                                                      1
                                                   )}
                                                   padding={2}
                                                />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calFirstTwist ? (
                                       <tr
                                          style={{
                                             border: "1px solid #4997d0",
                                             borderTop: "none",
                                             borderBottom: "none",
                                          }}
                                       >
                                          <td className="text-white text-center">
                                             <h5>First Stage</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>Twist Level</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`${_.toNumber(
                                                Specification.firstTwistMin
                                             ).toFixed(2)} - ${_.toNumber(
                                                Specification.firstTwistMax
                                             ).toFixed(2)}`}</h5>
                                          </td>
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"firstTwist_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.firstTwistMin}
                                                   max={Specification.firstTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"firstTwist_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.firstTwistMin}
                                                   max={Specification.firstTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"firstTwist_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.firstTwistMin}
                                                   max={Specification.firstTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"firstTwist_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.firstTwistMin}
                                                   max={Specification.firstTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"firstTwist_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.firstTwistMin}
                                                   max={Specification.firstTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"firstTwist_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.firstTwistMin}
                                                   max={Specification.firstTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"firstTwist_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.firstTwistMin}
                                                   max={Specification.firstTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"firstTwist_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.firstTwistMin}
                                                   max={Specification.firstTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"firstTwist_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.firstTwistMin}
                                                   max={Specification.firstTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={averageCalculator([
                                                      testInfo.firstTwist_T1_S1,
                                                      testInfo.firstTwist_T1_S2,
                                                      testInfo.firstTwist_T1_S3,
                                                      testInfo.firstTwist_T2_S1,
                                                      testInfo.firstTwist_T2_S2,
                                                      testInfo.firstTwist_T2_S3,
                                                      testInfo.firstTwist_T3_S1,
                                                      testInfo.firstTwist_T3_S2,
                                                      testInfo.firstTwist_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calStdDeviation([
                                                      testInfo.firstTwist_T1_S1,
                                                      testInfo.firstTwist_T1_S2,
                                                      testInfo.firstTwist_T1_S3,
                                                      testInfo.firstTwist_T2_S1,
                                                      testInfo.firstTwist_T2_S2,
                                                      testInfo.firstTwist_T2_S3,
                                                      testInfo.firstTwist_T3_S1,
                                                      testInfo.firstTwist_T3_S2,
                                                      testInfo.firstTwist_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={coefficientOfVariation([
                                                      testInfo.firstTwist_T1_S1,
                                                      testInfo.firstTwist_T1_S2,
                                                      testInfo.firstTwist_T1_S3,
                                                      testInfo.firstTwist_T2_S1,
                                                      testInfo.firstTwist_T2_S2,
                                                      testInfo.firstTwist_T2_S3,
                                                      testInfo.firstTwist_T3_S1,
                                                      testInfo.firstTwist_T3_S2,
                                                      testInfo.firstTwist_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calSecondTwist ? (
                                       <tr
                                          style={{
                                             border: "1px solid #4997d0",
                                             borderTop: "none",
                                             borderBottom: "none",
                                          }}
                                       >
                                          <td className="text-white text-center">
                                             <h5>Second Stage</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>Twist Level</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`${_.toNumber(
                                                Specification.secondTwistMin
                                             ).toFixed(2)} - ${_.toNumber(
                                                Specification.secondTwistMax
                                             ).toFixed(2)}`}</h5>
                                          </td>
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"twist_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.secondTwistMin}
                                                   max={Specification.secondTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"twist_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.secondTwistMin}
                                                   max={Specification.secondTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"twist_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.secondTwistMin}
                                                   max={Specification.secondTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"twist_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.secondTwistMin}
                                                   max={Specification.secondTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"twist_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.secondTwistMin}
                                                   max={Specification.secondTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"twist_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.secondTwistMin}
                                                   max={Specification.secondTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"twist_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.secondTwistMin}
                                                   max={Specification.secondTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"twist_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.secondTwistMin}
                                                   max={Specification.secondTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"twist_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.secondTwistMin}
                                                   max={Specification.secondTwistMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={averageCalculator([
                                                      testInfo.twist_T1_S1,
                                                      testInfo.twist_T1_S2,
                                                      testInfo.twist_T1_S3,
                                                      testInfo.twist_T2_S1,
                                                      testInfo.twist_T2_S2,
                                                      testInfo.twist_T2_S3,
                                                      testInfo.twist_T3_S1,
                                                      testInfo.twist_T3_S2,
                                                      testInfo.twist_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calStdDeviation([
                                                      testInfo.twist_T1_S1,
                                                      testInfo.twist_T1_S2,
                                                      testInfo.twist_T1_S3,
                                                      testInfo.twist_T2_S1,
                                                      testInfo.twist_T2_S2,
                                                      testInfo.twist_T2_S3,
                                                      testInfo.twist_T3_S1,
                                                      testInfo.twist_T3_S2,
                                                      testInfo.twist_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={coefficientOfVariation([
                                                      testInfo.twist_T1_S1,
                                                      testInfo.twist_T1_S2,
                                                      testInfo.twist_T1_S3,
                                                      testInfo.twist_T2_S1,
                                                      testInfo.twist_T2_S2,
                                                      testInfo.twist_T2_S3,
                                                      testInfo.twist_T3_S1,
                                                      testInfo.twist_T3_S2,
                                                      testInfo.twist_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calShrinkage ? (
                                       <tr
                                          style={{
                                             border: "1px solid #4997d0",
                                             borderTop: "none",
                                             borderBottom: "none",
                                          }}
                                       >
                                          <td className="text-blue text-center">
                                             <h5>&nbsp;</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>% Shrinkage</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`${_.toNumber(
                                                Specification.shrinkMin
                                             ).toFixed(2)} - ${_.toNumber(
                                                Specification.shrinkMax
                                             ).toFixed(2)}`}</h5>
                                          </td>
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"shrink_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.shrinkMin}
                                                   max={Specification.shrinkMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"shrink_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.shrinkMin}
                                                   max={Specification.shrinkMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"shrink_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.shrinkMin}
                                                   max={Specification.shrinkMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"shrink_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.shrinkMin}
                                                   max={Specification.shrinkMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"shrink_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.shrinkMin}
                                                   max={Specification.shrinkMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"shrink_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.shrinkMin}
                                                   max={Specification.shrinkMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"shrink_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.shrinkMin}
                                                   max={Specification.shrinkMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"shrink_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.shrinkMin}
                                                   max={Specification.shrinkMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"shrink_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.shrinkMin}
                                                   max={Specification.shrinkMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={averageCalculator([
                                                      testInfo.shrink_T1_S1,
                                                      testInfo.shrink_T1_S2,
                                                      testInfo.shrink_T1_S3,
                                                      testInfo.shrink_T2_S1,
                                                      testInfo.shrink_T2_S2,
                                                      testInfo.shrink_T2_S3,
                                                      testInfo.shrink_T3_S1,
                                                      testInfo.shrink_T3_S2,
                                                      testInfo.shrink_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calStdDeviation([
                                                      testInfo.shrink_T1_S1,
                                                      testInfo.shrink_T1_S2,
                                                      testInfo.shrink_T1_S3,
                                                      testInfo.shrink_T2_S1,
                                                      testInfo.shrink_T2_S2,
                                                      testInfo.shrink_T2_S3,
                                                      testInfo.shrink_T3_S1,
                                                      testInfo.shrink_T3_S2,
                                                      testInfo.shrink_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={coefficientOfVariation([
                                                      testInfo.shrink_T1_S1,
                                                      testInfo.shrink_T1_S2,
                                                      testInfo.shrink_T1_S3,
                                                      testInfo.shrink_T2_S1,
                                                      testInfo.shrink_T2_S2,
                                                      testInfo.shrink_T2_S3,
                                                      testInfo.shrink_T3_S1,
                                                      testInfo.shrink_T3_S2,
                                                      testInfo.shrink_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calFinish ? (
                                       <tr
                                          style={{
                                             border: "1px solid #4997d0",
                                             borderTop: "none",
                                             borderBottom: "none",
                                          }}
                                       >
                                          <td className="text-blue text-center">
                                             <h5>&nbsp;</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>Finish</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`${_.toNumber(
                                                Specification.finishMin
                                             ).toFixed(2)} - ${_.toNumber(
                                                Specification.finishMax
                                             ).toFixed(2)}`}</h5>
                                          </td>
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"finish_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.finishMin}
                                                   max={Specification.finishMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"finish_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.finishMin}
                                                   max={Specification.finishMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"finish_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.finishMin}
                                                   max={Specification.finishMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"finish_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.finishMin}
                                                   max={Specification.finishMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"finish_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.finishMin}
                                                   max={Specification.finishMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"finish_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.finishMin}
                                                   max={Specification.finishMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"finish_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.finishMin}
                                                   max={Specification.finishMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"finish_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.finishMin}
                                                   max={Specification.finishMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"finish_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.finishMin}
                                                   max={Specification.finishMax}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={averageCalculator([
                                                      testInfo.finish_T1_S1,
                                                      testInfo.finish_T1_S2,
                                                      testInfo.finish_T1_S3,
                                                      testInfo.finish_T2_S1,
                                                      testInfo.finish_T2_S2,
                                                      testInfo.finish_T2_S3,
                                                      testInfo.finish_T3_S1,
                                                      testInfo.finish_T3_S2,
                                                      testInfo.finish_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calStdDeviation([
                                                      testInfo.finish_T1_S1,
                                                      testInfo.finish_T1_S2,
                                                      testInfo.finish_T1_S3,
                                                      testInfo.finish_T2_S1,
                                                      testInfo.finish_T2_S2,
                                                      testInfo.finish_T2_S3,
                                                      testInfo.finish_T3_S1,
                                                      testInfo.finish_T3_S2,
                                                      testInfo.finish_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={coefficientOfVariation([
                                                      testInfo.finish_T1_S1,
                                                      testInfo.finish_T1_S2,
                                                      testInfo.finish_T1_S3,
                                                      testInfo.finish_T2_S1,
                                                      testInfo.finish_T2_S2,
                                                      testInfo.finish_T2_S3,
                                                      testInfo.finish_T3_S1,
                                                      testInfo.finish_T3_S2,
                                                      testInfo.finish_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calGauge ? (
                                       <tr
                                          style={{
                                             border: "1px solid #4997d0",
                                             borderTop: "none",
                                             borderBottom: "none",
                                          }}
                                       >
                                          <td className="text-blue text-center">
                                             <h5>&nbsp;</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>Gauge</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`${_.toNumber(
                                                Specification.gaugeMin
                                             ).toFixed(4)} - ${_.toNumber(
                                                Specification.gaugeMax
                                             ).toFixed(4)}`}</h5>
                                          </td>
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"gage_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.gaugeMin}
                                                   max={Specification.gaugeMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"gage_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.gaugeMin}
                                                   max={Specification.gaugeMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"gage_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.gaugeMin}
                                                   max={Specification.gaugeMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"gage_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.gaugeMin}
                                                   max={Specification.gaugeMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"gage_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.gaugeMin}
                                                   max={Specification.gaugeMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"gage_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.gaugeMin}
                                                   max={Specification.gaugeMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"gage_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.gaugeMin}
                                                   max={Specification.gaugeMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"gage_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.gaugeMin}
                                                   max={Specification.gaugeMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"gage_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.gaugeMin}
                                                   max={Specification.gaugeMax}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={averageCalculator([
                                                      testInfo.gage_T1_S1,
                                                      testInfo.gage_T1_S2,
                                                      testInfo.gage_T1_S3,
                                                      testInfo.gage_T2_S1,
                                                      testInfo.gage_T2_S2,
                                                      testInfo.gage_T2_S3,
                                                      testInfo.gage_T3_S1,
                                                      testInfo.gage_T3_S2,
                                                      testInfo.gage_T3_S3,
                                                   ])}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calStdDeviation([
                                                      testInfo.gage_T1_S1,
                                                      testInfo.gage_T1_S2,
                                                      testInfo.gage_T1_S3,
                                                      testInfo.gage_T2_S1,
                                                      testInfo.gage_T2_S2,
                                                      testInfo.gage_T2_S3,
                                                      testInfo.gage_T3_S1,
                                                      testInfo.gage_T3_S2,
                                                      testInfo.gage_T3_S3,
                                                   ])}
                                                   padding={4}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={coefficientOfVariation(
                                                      [
                                                         testInfo.gage_T1_S1,
                                                         testInfo.gage_T1_S2,
                                                         testInfo.gage_T1_S3,
                                                         testInfo.gage_T2_S1,
                                                         testInfo.gage_T2_S2,
                                                         testInfo.gage_T2_S3,
                                                         testInfo.gage_T3_S1,
                                                         testInfo.gage_T3_S2,
                                                         testInfo.gage_T3_S3,
                                                      ],
                                                      4
                                                   )}
                                                   padding={4}
                                                />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    {Specification.calSwellingFactor ? (
                                       <tr
                                          style={{
                                             border: "1px solid #4997d0",
                                             borderTop: "none",
                                             borderBottom: "none",
                                          }}
                                       >
                                          <td className="text-blue">
                                             <h5>&nbsp;</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>Swelling Factor</h5>
                                          </td>
                                          <td className="text-white text-center">
                                             <h5>{`Min: ${_.toNumber(Specification.swellingFactorMin).toFixed(0)}`}</h5>
                                          </td>
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"swell_T1_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.swellingFactorMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={0}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"swell_T1_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.swellingFactorMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={0}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"swell_T1_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.swellingFactorMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={0}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"swell_T2_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.swellingFactorMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={0}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"swell_T2_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.swellingFactorMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={0}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"swell_T2_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.swellingFactorMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={0}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"swell_T3_S1"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.swellingFactorMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={0}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"swell_T3_S2"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.swellingFactorMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={0}
                                                />
                                             }
                                          />
                                          <td
                                             style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                             children={
                                                <LocalNumberFormatWrapper
                                                   onChangeString={"swell_T3_S3"}
                                                   allowZeroPRP={false}
                                                   onChange={onChange}
                                                   testInfo={testInfo}
                                                   min={Specification.swellingFactorMin}
                                                   max={Number.MAX_VALUE}
                                                   padding={0}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={averageCalculator([
                                                      testInfo.swell_T1_S1,
                                                      testInfo.swell_T1_S2,
                                                      testInfo.swell_T1_S3,
                                                      testInfo.swell_T2_S1,
                                                      testInfo.swell_T2_S2,
                                                      testInfo.swell_T2_S3,
                                                      testInfo.swell_T3_S1,
                                                      testInfo.swell_T3_S2,
                                                      testInfo.swell_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={calStdDeviation([
                                                      testInfo.swell_T1_S1,
                                                      testInfo.swell_T1_S2,
                                                      testInfo.swell_T1_S3,
                                                      testInfo.swell_T2_S1,
                                                      testInfo.swell_T2_S2,
                                                      testInfo.swell_T2_S3,
                                                      testInfo.swell_T3_S1,
                                                      testInfo.swell_T3_S2,
                                                      testInfo.swell_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                          <td
                                             children={
                                                <LocalDebounceFormatterReadOnly
                                                   value={coefficientOfVariation([
                                                      testInfo.swell_T1_S1,
                                                      testInfo.swell_T1_S2,
                                                      testInfo.swell_T1_S3,
                                                      testInfo.swell_T2_S1,
                                                      testInfo.swell_T2_S2,
                                                      testInfo.swell_T2_S3,
                                                      testInfo.swell_T3_S1,
                                                      testInfo.swell_T3_S2,
                                                      testInfo.swell_T3_S3,
                                                   ])}
                                                   padding={2}
                                                />
                                             }
                                          />
                                       </tr>
                                    ) : null}

                                    <tr
                                       style={{
                                          border: "1px solid #4997d0",
                                          borderTop: "none",
                                          borderBottom: "none",
                                       }}
                                    >
                                       <td className="text-blue">
                                          <h5>&nbsp;</h5>
                                       </td>
                                       <td className="text-white text-center">
                                          <h5>Yield</h5>
                                       </td>
                                       <td className="text-white text-center">
                                          <h5>{`${_.toNumber(
                                             Specification.yieldMinTotalEnds
                                          ).toFixed(2)} - ${_.toNumber(
                                             Specification.yieldMaxTotalEnds
                                          ).toFixed(2)}`}</h5>
                                       </td>
                                       <td
                                          style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={calYieldTtl(testInfo.yarnSize_T1_S1)}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ backgroundColor: "#275d91" }}
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={calYieldTtl(testInfo.yarnSize_T1_S2)}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ backgroundColor: "#275d91" }}
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={calYieldTtl(testInfo.yarnSize_T1_S3)}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ borderTop: "1px solid white" }}
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={calYieldTtl(testInfo.yarnSize_T2_S1)}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={calYieldTtl(testInfo.yarnSize_T2_S2)}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={calYieldTtl(testInfo.yarnSize_T2_S3)}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ backgroundColor: "#275d91", borderTop: "1px solid white" }}
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={calYieldTtl(testInfo.yarnSize_T3_S1)}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ backgroundColor: "#275d91" }}
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={calYieldTtl(testInfo.yarnSize_T3_S2)}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          style={{ backgroundColor: "#275d91", borderBottom: "1px solid white" }}
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={calYieldTtl(testInfo.yarnSize_T3_S3)}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={averageCalculator(
                                                   [
                                                      testInfo.yarnSize_T1_S1,
                                                      testInfo.yarnSize_T1_S2,
                                                      testInfo.yarnSize_T1_S3,
                                                      testInfo.yarnSize_T2_S1,
                                                      testInfo.yarnSize_T2_S2,
                                                      testInfo.yarnSize_T2_S3,
                                                      testInfo.yarnSize_T3_S1,
                                                      testInfo.yarnSize_T3_S2,
                                                      testInfo.yarnSize_T3_S3,
                                                   ],
                                                   true
                                                )}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={calStdDeviation(
                                                   [
                                                      testInfo.yarnSize_T1_S1,
                                                      testInfo.yarnSize_T1_S2,
                                                      testInfo.yarnSize_T1_S3,
                                                      testInfo.yarnSize_T2_S1,
                                                      testInfo.yarnSize_T2_S2,
                                                      testInfo.yarnSize_T2_S3,
                                                      testInfo.yarnSize_T3_S1,
                                                      testInfo.yarnSize_T3_S2,
                                                      testInfo.yarnSize_T3_S3,
                                                   ],
                                                   true
                                                )}
                                                padding={2}
                                             />
                                          }
                                       />
                                       <td
                                          children={
                                             <LocalDebounceFormatterReadOnly
                                                value={coefficientOfVariation(
                                                   [
                                                      testInfo.yarnSize_T1_S1,
                                                      testInfo.yarnSize_T1_S2,
                                                      testInfo.yarnSize_T1_S3,
                                                      testInfo.yarnSize_T2_S1,
                                                      testInfo.yarnSize_T2_S2,
                                                      testInfo.yarnSize_T2_S3,
                                                      testInfo.yarnSize_T3_S1,
                                                      testInfo.yarnSize_T3_S2,
                                                      testInfo.yarnSize_T3_S3,
                                                   ],
                                                   2,
                                                   true
                                                )}
                                                padding={2}
                                             />
                                          }
                                       />
                                    </tr>
                                 </>
                              )}
                           </tbody>
                        </Table>
                        <Row className="mt-3">
                           <Col>
                              <Button
                                 className="shredButton float-end"
                                 style={{ marginRight: "15px" }}
                                 onClick={SaveTestData}
                                 disabled={isLoading}
                              >
                                 SAVE TEST DATA
                              </Button>
                           </Col>
                        </Row>
                     </div>
                  </div>
               ) : (
                  <div>
                     <span>
                        The associated test results and specification did not render any
                        results
                     </span>
                  </div>
               )
            }
         />
      </DesktopContainer>
   );
}
